// import React, {Component} from 'react';
import {
  View,
  Text
} from 'react-native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c20v1a from './c20v1a';
import c30v1a from './c30v1a'; // 団体情報
import c60v1a from './c60v1a';
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
import i14v1a from './i14v1a'; // 設定情報


import cView from './cView';

import myPD from './myPD_20211208';
import myXL from './myXL_20211211';
import myWB from './myWB_20211212';

export default class i1zv extends cView { // 設備予約　管理用用画面

/*
constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}
*/

/*
$cd_stgs = { //  子で上書き
  mode: 'nml', // nml: normal, tdy: today
};
*/

$cd_stss = { // 親を上書き
  sdld_i1zrSlcListsss: {i1zr:[]},
  sdld_i1zrDtlsss: {i1zr:[]},
  sdld_i1z0Listsss: {i1z0:[]},
  sdld_i1z0Dtlsss: {i1z0:[]},
  sdld_c30rDtlsss: {c30r:[]},
  sdld_i110SlcListsss: {i110:[]},
  s_i1zr_key: -1,
  sb_chk: false,
  sl_dates: [],
  s_acnDateStt: '', // application date start 申込開始日
  s_acnDateEnd: '', // application date end 申込終了日
  s_rsvDateStt: '', // reserve date start 予約開始日
  s_rsvDateEnd: '', // reserve date end 予約終了日
  s_i1zrb31f: -1,
  s_i1zri21dStt: null,
  s_i1zri21dEnd: null,
  s_i1zrs11i: 99,
  s_i1zrs21i: -1,
  s_i1zrs22i: -1,
};

static op_loadList = (pd={
  elm: null,
  o_cnd: null,
}) => 
  (pd.elm == 'i1zr') ? 
    super.op_loadList({
      ...pd,
      dd_rfrss: {
        c30r: {
          elm: 'c30r',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`c30r`, `_fst = ${_d_flds.i1zrb31f}`)
            return _cnd;
          },
        },
        i1z1: {
          elm: 'i1z1',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`i1z1`, `i1z1b61k = ${_d_flds._key}`, false, false)
            return _cnd;
          },
        },
        i10r: {
          elm: 'i10r',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1zrb41f}`)
            return _cnd;
          },
        },
      },
      dd_cldDefss: {
        i1z0: { // alias
          elm: 'i1z0',
          o_cnd: _dd_datss => {
            let _cnd = cf.c(`i1z0`, `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
            return _cnd;
          },
          dd_rfrss: {
            i110: {
              elm: 'i110',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i110`, `_fst = ${_d_flds.i1z0b51f}`)
                return _cnd;
              },
            },
          },
        },
        i1z2: { // alias
          elm: 'i1z2',
          o_cnd: _dd_datss => {
            let _cnd = cf.c(`i1z2`, `i1z2b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
            return _cnd;
          },
          dd_rfrss: {
            i10r: {
              elm: 'i10r',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1z2b41f}`)
                return _cnd;
              },
            },
          },
        },
      },      
    })
  : super.op_loadList(pd)
;

static op_loadDtl = (pd={
  elm: '',
  fst: null,
  key: null,
}) => 
  (pd.elm == 'i1zr') ? 
    super.op_loadDtl({
      ...pd,
      dd_rfrss: {
        c30r: { // 利用申請書の出力に必要
          elm: 'c30r',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`c30r`, `_fst = ${_d_flds.i1zrb31f}`)
            return _cnd;
          },
        },
        i10r: { // 室
          elm: 'i10r',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1zrb41f}`)
            return _cnd;
          },
        },
        i1z1: {
          elm: 'i1z1',
          o_cnd: _d_flds => {
            let _cnd = cf.c(`i1z1`, `i1z1b61k = ${_d_flds._key}`, false, false)
            return _cnd;
          },
        },
      },
      dd_cldDefss: {
        i1z0: { // 利用室情報
          elm: 'i1z0',
          o_cnd: _dd_datss => {
            let _cnd = cf.c(`i1z0`, `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
            return _cnd;
          },
          dd_rfrss: {
            i110: { // 時間帯
              elm: 'i110',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i110`, `_fst = ${_d_flds.i1z0b51f}`)
                return _cnd;
              },
            },
          },
          ld_sortss: [
            { fld: 'i110cx1i', dtn: 'asc', mode: 'nmb' }
          ],
        },
        i1z2: { // 利用設備情報
          elm: 'i1z2',
          o_cnd: _dd_datss => {
            let _cnd = cf.c(`i1z2`, `i1z2b61k = ${_dd_datss.i1zr.d_flds._key} AND i1z2b41f > 0`, false, false);
            return _cnd;
          },
          dd_rfrss: {
            i10r: {
              elm: 'i10r',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1z2b41f}`)
                return _cnd;
              },
            },
          },
        },
      },
      op_atrAll: () => new Promise( _o_end1 => {
        let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
        c30v1a.op_loadDtl({ // 予約・エントリー状況の表示に必要
          elm: 'c30r',
          fst: _d_i1zrs.d_flds.i1zrb31f,
        })
        .then(() => {
          i11v1a.op_loadSlcList({ // 時間帯の表示に必要
            elm: 'i110',
            i11r_fst: _d_i1zrs.d_flds.i10rb51f,
          })
          .then(() => {
            let _l_i110_fsts = [];
            _d_i1zrs.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
              _l_i110_fsts.push(_d_i1z0s.d_flds.i1z0b51f);
            });
            global.t?.state.sdld_i110SlcListsss?.i110.map( (_d_i110s, _i110Idx) => { // 時間帯の設定
              cf.myRN_setStt({
                [`s_time${_d_i110s.d_flds._fst}`]: ff.i(_d_i110s.d_flds._fst, _l_i110_fsts) ? 1 : 0,
              });
            });
            _o_end1();
          })
        });
      }),
    })
  : super.op_loadDtl(pd)
;

$clp_bfrLoadLists = () => [
  new Promise( _o_end1 => {
    let _stt = null;
    let _end = null;
    switch (global.t?.d_viewDefs.class) {
      case 'i1zv1a':
        _stt = (global.t?.state.s_i1zri21dStt == null) ? ff.myDT_getDate('today') : global.t?.state.s_i1zri21dStt;
        _end = (global.t?.state.s_i1zri21dEnd == null) ? ff.myDT_add('day', _stt, 7) : global.t?.state.s_i1zri21dEnd;
        cf.myRN_setStt({
          s_i1zri21dStt: _stt,
          s_i1zri21dEnd: _end,
        })
        .then(_o_end1);
        break;
      case 'i1zv1b':
        _stt = (global.t?.state.s_i1zri21dStt == null) ? ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), 2) : global.t?.state.s_i1zri21dStt;
        _end = (global.t?.state.s_i1zri21dEnd == null) ? ff.myDT_cnv('ldm', _stt) : global.t?.state.s_i1zri21dEnd;
        cf.myRN_setStt({
          s_i1zri21dStt: _stt,
          s_i1zri21dEnd: _end,
        })
        .then(_o_end1);
        break;
      case 'i1zv1c':
        _stt = (global.t?.state.s_i1zri21dStt == null) ? ff.myDT_add('mth', ff.myDT_cnv('fdm', ff.myDT_getDate('today')), 3) : global.t?.state.s_i1zri21dStt;
        _end = (global.t?.state.s_i1zri21dEnd == null) ? ff.myDT_cnv('ldm', _stt) : global.t?.state.s_i1zri21dEnd;
        cf.myRN_setStt({
          s_i1zri21dStt: _stt,
          s_i1zri21dEnd: _end,
        })
        .then(_o_end1);
        break;
      default:
        _o_end1();
    };
  }),
];

$clp_loadLists = () => [ // 親を上書き
  i1zv.op_loadSlcList({ // 予約・エントリー情報
    elm: `i1zr`,
    o_cnd: _dd_datss => {      
      let _cnd = 
        bf.i(global.t?.d_viewDefs.class, ['i1zv1a']) ? // スタッフ用 直接予約
          cf.c(`i1zr`, `i1zrs11i IN (20, 70, 80, 90)`)
        : bf.i(global.t?.d_viewDefs.class, ['i1zv1b']) ? // スタッフ用 エントリー
          cf.c(`i1zr`, `i1zrs21i IN (20, 40, 60, 80)`)
        : bf.i(global.t?.d_viewDefs.class, ['i1zv1c']) ? // スタッフ用 優先エントリー
          cf.c(`i1zr`, `i1zrs22i IN (20, 40, 60, 80)`)
        : bf.i(global.t?.d_viewDefs.class, ['i1zv2a']) ? // 団体用 直接予約
          cf.c(`i1zr`, `i1zrs11i IN (70, 80, 90) AND i1zrb31f = ${global.t?.state.sgcd_cmnStgs.c10rb31f} AND i1zri21d >= "${ff.myDT_getDate('today')}"`)
        : bf.i(global.t?.d_viewDefs.class, ['i1zv2b']) ? // 団体用 エントリー
          cf.c(`i1zr`, `i1zrs21i IN (40, 60, 80) AND i1zrb31f = ${global.t?.state.sgcd_cmnStgs.c10rb31f} AND i1zri21d LIKE "${ff.myDT_add('mth', ff.myDT_getDate('today'), 2).substr(0,7)}%"`)
        : bf.i(global.t?.d_viewDefs.class, ['i1zv2c']) ? // 団体用 優先エントリー
          cf.c(`i1zr`, `i1zrs22i IN (40, 60, 80) AND i1zrb31f = ${global.t?.state.sgcd_cmnStgs.c10rb31f} AND i1zri21d LIKE "${ff.myDT_add('mth', ff.myDT_getDate('today'), 3).substr(0,7)}%"`)
        : bf.i(global.t?.d_viewDefs.class, ['i1zv3a']) ? // スタッフ用 使用状況
          cf.c(`i1zr`, `i1zrs11i IN (0, 20, 70, 80, 90)`)
        : null;
      if (ff.i(global.t?.d_viewDefs.class, ['i1zv1a'])) { // スタッフ用直接予約 一覧画面
        if (global.t?.state.s_i1zrb31f > -1) _cnd += ` AND i1zrb31f = ${global.t?.state.s_i1zrb31f}`; // 団体
        if (ff.f(global.t?.state.s_i1zri21dStt)) _cnd += ` AND i1zri21d >= "${global.t?.state.s_i1zri21dStt}"`; // 利用日
        if (ff.f(global.t?.state.s_i1zri21dEnd)) _cnd += ` AND "${global.t?.state.s_i1zri21dEnd}" >= i1zri21d`; // 利用日
        if (global.t?.state.s_i1zrs11i > -1 && global.t?.state.s_i1zrs11i != 99) _cnd += ` AND i1zrs11i = ${global.t?.state.s_i1zrs11i}`; // 予約状況
        if (global.t?.state.s_i1zrs11i > -1 && global.t?.state.s_i1zrs11i == 99) _cnd += ` AND i1zrs11i IN (80, 90)`; // 予約状況、仮予約＋本予約
      };
      if (ff.i(global.t?.d_viewDefs.class, ['i1zv1b'])) { // スタッフ用エントリー 一覧画面
        if (global.t?.state.s_i1zrb31f > -1) _cnd += ` AND i1zrb31f = ${global.t?.state.s_i1zrb31f}`; // 団体
        if (ff.f(global.t?.state.s_i1zri21dStt)) _cnd += ` AND i1zri21d >= "${global.t?.state.s_i1zri21dStt}"`; // 利用日
        if (ff.f(global.t?.state.s_i1zri21dEnd)) _cnd += ` AND "${global.t?.state.s_i1zri21dEnd}" >= i1zri21d`; // 利用日
        if (global.t?.state.s_i1zrs21i > -1) _cnd += ` AND i1zrs21i = ${global.t?.state.s_i1zrs21i}`; // エントリー状況
      };
      if (ff.i(global.t?.d_viewDefs.class, ['i1zv1c'])) { // スタッフ用優先エントリー 一覧画面
        if (global.t?.state.s_i1zrb31f > -1) _cnd += ` AND i1zrb31f = ${global.t?.state.s_i1zrb31f}`; // 団体
        if (ff.f(global.t?.state.s_i1zri21dStt)) _cnd += ` AND i1zri21d >= "${global.t?.state.s_i1zri21dStt}"`; // 利用日
        if (ff.f(global.t?.state.s_i1zri21dEnd)) _cnd += ` AND "${global.t?.state.s_i1zri21dEnd}" >= i1zri21d`; // 利用日
        if (global.t?.state.s_i1zrs22i > -1) _cnd += ` AND i1zrs22i = ${global.t?.state.s_i1zrs22i}`; // 優先エントリー状況
      };
      if (ff.i(global.t?.d_viewDefs.class, ['i1zv2a'])) { // 団体用直接予約 一覧画面
        if (ff.f(global.t?.state.s_i1zri21dStt)) _cnd += ` AND i1zri21d >= "${global.t?.state.s_i1zri21dStt}"`; // 利用日
        if (ff.f(global.t?.state.s_i1zri21dEnd)) _cnd += ` AND "${global.t?.state.s_i1zri21dEnd}" >= i1zri21d`; // 利用日
        if (global.t?.state.s_i1zrs11i > -1 && global.t?.state.s_i1zrs11i != 99) _cnd += ` AND i1zrs11i = ${global.t?.state.s_i1zrs11i}`; // 予約状況
        if (global.t?.state.s_i1zrs11i > -1 && global.t?.state.s_i1zrs11i == 99) _cnd += ` AND i1zrs11i IN (80, 90)`; // 予約状況、仮予約＋本予約
      };
      if (ff.i(global.t?.d_viewDefs.class, ['i1zv2b'])) { // 団体用エントリー 一覧画面
      };
      if (ff.i(global.t?.d_viewDefs.class, ['i1zv2c'])) { // 団体用優先エントリー 一覧画面
      };
      return _cnd;
    },
    ld_sortss: [
      { fld: `i1zri21d`, dtn: 'asc', mode: 'str'},
      { fld: `i1zrc11s`, dtn: 'asc', mode: 'str'},
    ],
    dd_rfrss: {
      c30r: {
        elm: 'c30r',
        o_cnd: _d_flds => {
          let _cnd = cf.c(`c30r`, `_fst = ${_d_flds.i1zrb31f}`)
          return _cnd;
        },
      },
    },
  }),
  c20v1a.op_loadDtl({ // 設定
    elm: 'c20r',
  }),
  bf.i(global.t?.d_viewDefs.class, ['i1zv1a', 'i1zv1b', 'i1zv1c']) ?
    c30v1a.op_loadSlcList({ // スタッフ用
      elm: 'c30r',
      op_atrAll: () => new Promise( _o_end1 => { // i10r の呼出範囲は、スタッフと団体で異なる
        Promise.all([
          i10v1a.op_loadSlcList({ // 室
            elm:'i10r',
            i10rt11i: 200,
            state: 'sdld_i10rSlcListsss',
          }),
          i10v1a.op_loadSlcList({ // 設備
            elm:'i10r',
            i10rt11i: 400,
            state: 'sdld_i10rSlcListsss2',
          }), // 室・設備
        ])
        .then(_o_end1);
      }),
    })
  : null,
  bf.i(global.t?.d_viewDefs.class, ['i1zv2a', 'i1zv2b', 'i1zv2c']) ?
    c30v1a.op_loadDtl({ // 団体用
      elm: 'c30r',
      fst: global.t?.state.sgcd_cmnStgs?.c10rb31f,
      op_atrAll: () => new Promise( _o_end1 => { // 選択可能な室・設備を限定
        Promise.all([
          i10v1a.op_loadSlcList({ // 室
            elm:'i10r',
            state: 'sdld_i10rSlcListsss',
            o_cnd: _dd_datss => {
              let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
              let _cnd = null;
              _cnd = cf.c('i15r', `_fst = ${_d_c30rs.d_flds.c30rbk1f}`);
              _cnd = cf.c('i150', `i150br1k = (SELECT _key FROM t_i15r WHERE ${_cnd})`, false, false);
              _cnd = `i10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst} AND _vsn = _ltt AND i10rt11i = 200 AND _fst NOT IN (SELECT i150b41f FROM t_i150 WHERE ${_cnd})`; // 200 に限定
              return _cnd;
            },
          }),
          i10v1a.op_loadSlcList({ // 設備
            elm:'i10r',
            i10rt11i: 400,
            state: 'sdld_i10rSlcListsss2',
            o_cnd: _dd_datss => {
              let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
              let _cnd = null;
              _cnd = cf.c('i15r', `_fst = ${_d_c30rs.d_flds.c30rbk1f}`);
              _cnd = cf.c('i150', `i150br1k = (SELECT _key FROM t_i15r WHERE ${_cnd})`, false, false);
              _cnd = `i10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst} AND _vsn = _ltt AND i10rt11i = 400 AND _fst NOT IN (SELECT i150b41f FROM t_i150 WHERE ${_cnd})` // 400 に限定
              return _cnd;
            },
          }), // 室・設備
        ])
        .then(_o_end1);
      }),
    })
  : null,
];

$clp_loadDtls = () => [
  i1zv.op_loadDtl({
    elm: 'i1zr',
    op_atrAll: _dld_datsss => new Promise( async _o_end1 => {
      await i11v1a.op_loadSlcList({ // 時間帯
        elm: 'i110',
        i11r_fst: _dld_datsss.i1zr[0]?.d_flds.i10rb51f,
      })
      _o_end1();
    })
  }),
  i1zv.op_loadVsnList({
    elm: `i1zr`,
  }),
];

static op_updHdys = (pd={
  sttDate: null,
  endDate: null,
}) => new Promise( _o_end1 => {
  c60v1a.op_loadSlcList({
    elm: 'c600',
    sttDate: pd.sttDate,
    endDate: pd.endDate,
  })
  .then(() => {
    let _l_hdys = [];
    global.t?.state.sdld_c600SlcListsss.c600.map( _d_c600s => {
      _l_hdys.push(_d_c600s.d_flds.c600i11d);
    });
    cf.myRN_setStt({
      sl_hdys: _l_hdys,
    })
    .then(_o_end1)
  });
});

_op_loadCdrList2 = (pd={
  state1: null,
  state2: null,
  date: null,
}) => new Promise( _o_end1 => {

  let _date = pd.date ?? ff.myDT_getDate('today');

  let _sttDate = ff.myDT_cnv('fdw', _date);
  let _endDate = ff.myDT_add('day', _sttDate, ic.g_dvcMode == 's' ? 6 : 13);

  let _l_i10r_fsts = [];
  let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
  let _fst = null;
  _fst = cf.myRN_getFldVal(_d_i1zrs, 'i1zrb41f', '_fst', 'i10r_fst');
  if (_fst) _l_i10r_fsts.push(_fst);
  _d_i1zrs?.dld_cldDatsss?.i1z2?.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true) ? true : false )
  .map( _d_i1z2s => {
    _fst = _d_i1z2s.d_flds.i1z2b41f;
    if (_fst) _l_i10r_fsts.push(_fst);
  });

  if (ff.f(_date) == false || ff.f(_l_i10r_fsts) == false) { // 会場または日付が指定されていない場合
    _o_end1();
  }
  else {

    i1zv.op_updHdys({ // 休館日の取得
      sttDate: _sttDate,
      endDate: _endDate,
    })
    .then(() => {

      global.t?.setState({
        [pd.state2]: ff.myDT_cnv('dates', {
          stt: _sttDate, // 暫定
          end: _endDate, // 暫定
        })
      }, () => {
        cr.myCB_call_tree({
          ctr: 'slc',
          state: pd.state1,
          b_ltt: true,
          dd_elmDefss: {
            i10r: { // ctg
              elm: 'i10r',
              o_cnd: _dd_datss => {
                let _cnd = '';
                _l_i10r_fsts.map( _i10r_fst => {
                  _cnd += (ff.f(_cnd) ? ', ' : '') + _i10r_fst; 
                });
                _cnd = cf.c(`i10r`, `_fst IN (${_cnd})`);
                return _cnd;
              },
              ld_sortss: [
                { fld: 'i10rt11i', dtn: 'asc', mode: 'nmb' },
                { fld: 'i10rc11s', dtn: 'asc', mode: 'nmb' },
              ],
              dd_cldDefss: {
                i110: { // dtl
                  elm: 'i110',
                  o_cnd: _dd_datss => {
                    let _cnd = cf.c(`i110`, `
                      i110b51k = (
                        SELECT 
                          _key 
                        FROM 
                          t_i11r 
                        WHERE 
                          COALESCE(i11rcz1i, 10) <> 0 AND 
                          i11rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst} AND 
                          _fst = ${_dd_datss.i10r.d_flds.i10rb51f} AND 
                          _vsn = _ltt
                      )
                    `);
                    return _cnd;
                  },
                  ld_sortss: [
                    { fld: 'i110c11s', dtn: 'asc', mode: 'nmb', },
                  ],
                  dd_cldDefss: {
                    i1z0: { // alias
                      elm: 'i1z0',
                      o_cnd: _dd_datss => {
                        let _cnd = cf.c(`i1z0`, `
                          i1z0b41f = ${_dd_datss.i10r.d_flds._fst} 
                          AND i1z0b51f = ${_dd_datss.i110.d_flds._fst}
                          AND i1z0i21d >= "${_sttDate}"
                          AND i1z0i21d <= "${_endDate}"
                          AND EXISTS (SELECT * FROM t_i1zr WHERE t_i1zr._key = i1z0b61k AND t_i1zr._vsn = t_i1zr._ltt AND (i1zrs11i >= 70 OR i1zrs21i >= 40 OR i1zrs22i >= 40))
                        `);
//                          AND EXISTS (SELECT * FROM t_i1zr WHERE t_i1zr._key = i1z0b61k AND t_i1zr._vsn = t_i1zr._ltt AND (i1zrs11i >= 70 OR i1zrs21i >= 40))
                        return _cnd;
                      },
                      dd_rfrss: {
                        i10r: {
                          elm: 'i10r',
                          o_cnd: _d_flds => {
                            let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1z0b41f}`);;
                            return _cnd;
                          },
                        },
                        i1zr: {
                          elm: 'i1zr',
                          o_cnd: _d_flds => {
                            let _cnd = cf.c(`i1zr`, `_key = ${_d_flds.i1z0b61k}`);;
                            return _cnd;
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          op_atrAll: () => new Promise( _o_end1 => {

            let _ld_i110ss = [];
            global.t?.state[pd.state1].i10r.map( (_d_i10rs, _idxI10r) => { // 室の時間帯区分
              if (_d_i10rs.d_flds.i10rt11i == 200) { // 室の場合
                _ld_i110ss = _d_i10rs.dld_cldDatsss.i110;
              };
            });

            let _ddd_dtlsss = {};

            Promise.all(
              global.t?.state[pd.state1].i10r.map( (_d_i10rs, _idxI10r) => new Promise( _o_end2 => {
                if (_d_i10rs.d_flds.i10rt11i == 400) { // 設備の場合
                  let _cnd = cf.c(`i1z2`, `i1z2b61k = i1z0b61k AND i1z2b41f = ${_d_i10rs.d_flds._fst}`);
                  //_cnd = cf.c(`i1z0`, `(i1z0i21d >= "${_sttDate}" AND "${_endDate}" >= i1z0i21d) AND EXISTS (SELECT * FROM t_i1z2 WHERE ${_cnd})`);
                  _cnd = cf.c(`i1z0`, `(i1z0i21d >= "${_sttDate}" AND "${_endDate}" >= i1z0i21d) AND EXISTS (SELECT * FROM t_i1z2 WHERE ${_cnd}) AND EXISTS ( SELECT * FROM t_i1zr WHERE COALESCE(i1zrcz1i,10) <> 0 AND i1zrs11i IN (70, 80, 90) AND t_i1zr._key = i1z0b61k )`);
                  let _d_cashs = {};
                  cf.myCB_call_slc({
                    elm: 'i1z0',
                    n_dms: 3,
                    cnd: _cnd,
                    dd_rfrss: {
                      i1zr: {
                        elm: 'i1zr',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c(`i1zr`, `_key = ${_d_flds.i1z0b61k}`);;
                          return _cnd;
                        },
                      },
                      i110: {
                        elm: 'i110',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c(`i110`, `_fst = ${_d_flds.i1z0b51f}`);
                          return _cnd;
                        },
                      },
                      i1z2: {
                        elm: 'i1z2',
                        o_cnd: _d_flds => {
                          let _cnd = cf.c(`i1z2`, `i1z2b61k = ${_d_flds.i1z0b61k} AND i1z2b41f = ${_d_i10rs.d_flds._fst}`);
                          return _cnd;
                        },
                      }
                    },
                    d_cashs: _d_cashs,
                  })
                  .then( _ld_fldss => { // _d_i1z0Flds
                    _ld_fldss.map( _d_flds => {
                      let _date = _d_flds.i1z0i21d;
                      let _n_maxCnt = _d_i10rs.d_flds.i10ri11i;
                      _ld_i110ss.map( _d_i110s => {
                        let _i10r_fst = `${_d_i10rs.d_flds._fst}`;
                        let _i110c31s = _d_i110s.d_flds.i110c31s;
                        if (!_ddd_dtlsss[_i10r_fst]) _ddd_dtlsss[_i10r_fst] = {};
                        if (!_ddd_dtlsss[_i10r_fst][_i110c31s]) _ddd_dtlsss[_i10r_fst][_i110c31s] = {};
                        let _b = (ff.n(_d_i110s.d_flds.i110i12t) > ff.n(_d_flds.i110i11t)) && (ff.n(_d_flds.i110i12t) > ff.n(_d_i110s.d_flds.i110i11t));
                        if (_b) {
/*
                          if (!_ddd_dtlsss[_i10r_fst][_i110c31s][_date]) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date] = { 
                              n_cnt: 0, 
                              pfx: ''
                            };
                          };
                          _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_cnt += 1;
                          if (ff.i(global.t?.d_viewDefs.class, ['i1zv1a', 'i1zv2a'])) { // 直接予約の場合
                            if (_ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_cnt >= _n_maxCnt) {
                              _ddd_dtlsss[_i10r_fst][_i110c31s][_date].pfx = '×';
                            };
                          };
                          if (ff.i(global.t?.d_viewDefs.class, ['i1zv1b', 'i1zv2b'])) { // エントリの場合
                            if (_ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_cnt > 0) {
                              _ddd_dtlsss[_i10r_fst][_i110c31s][_date].pfx = '△';
                            };
                          };
*/
                          if (!_ddd_dtlsss[_i10r_fst][_i110c31s][_date]) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date] = { 
                              n_rsvCnt: 0, 
                              n_alyCnt: 0, 
                              n_pryCnt: 0, 
                              pfx: ''
                            };
                          };

                          if (ff.i(_d_flds.i1zrs11i, [70, 80, 90])) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_rsvCnt += 1;
                          }
                          else if (ff.i(_d_flds.i1zrs21i, [40])) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_alyCnt += 1;
                          }
                          else if (ff.i(_d_flds.i1zrs22i, [40])) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_pryCnt += 1;
                          };

                          if (_ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_rsvCnt >= _n_maxCnt) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].pfx = '×';
                          }
                          else if (
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_rsvCnt > 0 ||
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_alyCnt > 0 ||
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].n_pryCnt > 0
                          ) {
                            _ddd_dtlsss[_i10r_fst][_i110c31s][_date].pfx = '△';
                          };
                        };
                      })
                    });
                    _o_end2();
                  });
                }
                else {
                  _o_end2();
                };
              }))
            )
            .then(() => {
              global.t?.setState({
                [pd.state1]: bf.p( global.t?.state[pd.state1], _next => {
                  if (_next) _next.i10r.map( (_d_i10rs, _idxI10r) => {
                    _d_i10rs.d_tbls = { pfx: _d_i10rs.d_flds.i10rc31s, d_is: {} }; // ctg

                    let _n_maxCnt = _d_i10rs.d_flds.i10ri11i;

                    if (_d_i10rs.d_flds.i10rt11i == 200) { // 室の場合
                      _d_i10rs.dld_cldDatsss.i110.map( (_d_i110s, _idxI110) => {
                        _d_i110s.d_tbls = { pfx: _d_i110s.d_flds.i110c31s, d_is: {} }; // dtl
                        _d_i110s.dld_cldDatsss?.i1z0.map( (_d_i1z0s, _idxI1i0) => { // 室
//ff.l('i1zv 660: {}'.f(_d_i1z0s))
/*
                          if (ff.f(_d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d]) == false) {
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d] = { n_cnt: 0, pfx: ''};
                          };
                          _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_cnt += 1
                          if (ff.i(global.t?.d_viewDefs.class, ['i1zv1a', 'i1zv2a'])) { // 直接予約の場合
                            if (_d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_cnt >= _n_maxCnt) {
                              _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].pfx = '×';
                            }
                          };
                          if (ff.i(global.t?.d_viewDefs.class, ['i1zv1b', 'i1zv2b'])) { // エントリの場合
                            if (_d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_cnt > 0) {
                              _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].pfx = '△';
                            };
                          };
*/
                          if (ff.f(_d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d]) == false) {
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d] = { 
                              n_rsvCnt: 0, 
                              n_alyCnt: 0, 
                              n_pryCnt: 0, 
                              pfx: ''
                            };
                          };
                          if (ff.i(_d_i1z0s.d_flds.i1zrs11i, [70, 80, 90])) {
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_rsvCnt += 1;
                          }
                          else if (ff.i(_d_i1z0s.d_flds.i1zrs21i, [40])) {
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_alyCnt += 1;
                          }
                          else if (ff.i(_d_i1z0s.d_flds.i1zrs22i, [40])) {
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_pryCnt += 1;
                          };
                          if (_d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_rsvCnt >= _n_maxCnt) {
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].pfx = '×';
                          }
                          else if (
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_rsvCnt > 0 ||
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_alyCnt > 0 ||
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_pryCnt > 0
                          ) {
//ff.l('i1zv 743: {}, {}, {}'.f(_d_i1z0s.d_flds.i1z0i21d, _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_rsvCnt, _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].n_alyCnt))
                            _d_i110s.d_tbls.d_is[_d_i1z0s.d_flds.i1z0i21d].pfx = '△';
                          };
                        });
                      })
                    };

                    if (_d_i10rs.d_flds.i10rt11i == 400) { // 設備の場合
                      _d_i10rs.dld_cldDatsss.i110 = [];
                      let _i10r_fst = `${_d_i10rs.d_flds._fst}`;
                      if (_ddd_dtlsss[_i10r_fst]) Object.keys(_ddd_dtlsss[_i10r_fst]).map( _i110c31s => {
                        let _dd_dtlss = _ddd_dtlsss[_i10r_fst][_i110c31s];
                        _d_i10rs.dld_cldDatsss.i110.push( { d_tbls: { pfx: _i110c31s, d_is: _dd_dtlss} } );
                      })
                    };
                  } )
                }),
              }, () => {
                _o_end1();
              });
            });

          }),

        })
        .then(() => {
          _o_end1();
        });
      })
    });
  }

});

static op_updStt = (pd={
  fst: null, // 抽選用
  i1zrs11i: null, // 抽選用
  i1zrs21i: null, // 抽選用
  i1zrs22i: null, // 抽選用
}) => new Promise( _o_end1 => {
//ff.l('677: {} '.f(pd.fst))
  i1zv.op_loadDtl({
    elm: 'i1zr',
//    cnd: cf.c('i1zr', `_fst = ${pd.fst}`)
    fst: pd.fst,
  })
  .then(() =>{
    let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
    cf.myRN_setDat('sdld_i1zrDtlsss', _d_i1zrs, _d_nextDats => {
      return {
        i1zrs11i: pd.i1zrs11i,
        i1zrs21i: pd.i1zrs21i,
        i1zrs22i: pd.i1zrs22i,
      };
    })
    .then(() => {
//      i1zv.op_upd()
      i1zv._updI1zrDtl()
      .then(() => {
        _o_end1();
      })
    });
  })

});

static _updI1zrDtl = () => cr.myCB_call_tree({ // op_updStt から呼び出すため static
  ctr: 'iud',
  state: 'sdld_i1zrDtlsss',
  b_vsn: true, // 歴管理
  dd_elmDefss: {
    i1zr: {
      elm :'i1zr',
      b_setPageKey: true,
      od_insDats: _dd_datss => {
        let _d = {
          i1zrb41f: _dd_datss.i1zr.d_flds.i1zrb41f ?? -1,
          i1zrt11i: _dd_datss.i1zr.d_flds.i1zrt11i ?? -1,
          i1zrt21i: _dd_datss.i1zr.d_flds.i1zrt21i ?? -1,
          i1zrb31f: _dd_datss.i1zr.d_flds.i1zrb31f ?? -1,
          i1zrc11s: ff.myCM_pdd(bf.n(_dd_datss.i1zr.d_flds.i1zrc11s), 5, '0') ?? '',
          i1zrs11i: _dd_datss.i1zr.d_flds.i1zrs11i ?? 0,
          i1zrs21i: _dd_datss.i1zr.d_flds.i1zrs21i ?? 0,
          i1zrs22i: _dd_datss.i1zr.d_flds.i1zrs22i ?? 0,
          i1zri11d: _dd_datss.i1zr.d_flds.i1zri11d ?? '',
          i1zri21d: _dd_datss.i1zr.d_flds.i1zri21d ?? '',
          i1zri11s: _dd_datss.i1zr.d_flds.i1zri11s ?? '',
          i1zri12s: _dd_datss.i1zr.d_flds.i1zri12s ?? '',
          i1zri21s: _dd_datss.i1zr.d_flds.i1zri21s ?? '',
          i1zri22s: _dd_datss.i1zr.d_flds.i1zri22s ?? '',
          i1zri31s: _dd_datss.i1zr.d_flds.i1zri31s ?? '',
          i1zri32s: _dd_datss.i1zr.d_flds.i1zri32s ?? '',
          i1zrt41i: _dd_datss.i1zr.d_flds.i1zrt41i ?? -1,
          i1zri41s: _dd_datss.i1zr.d_flds.i1zri41s ?? '',
          i1zri41i: ff.n(_dd_datss.i1zr.d_flds.i1zri41i) ??  0,
          i1zri11m: _dd_datss.i1zr.d_flds.i1zri11m ??  0,
          i1zri51s: _dd_datss.i1zr.d_flds.i1zri51s ?? '',
        };
//ff.l('689: {}'.f(_d));
        return _d;
      },
      op_atrIns: _d_dats => new Promise( _o_end1 => { // 混在 elm への対応
        cr.myCB_call_tree({ // 支払情報
          ctr: 'iud',
          state: 'sdld_i1zrDtlsss',
          b_vsn: true, // 歴管理 + elm 混在
          dd_elmDefss: {
            i1zr: {
              elm :'i1z1', // 支払情報
              b_setPageKey: false,
              od_insDats: _dd_datss => {
                let _d = {
                  i1z1b61k: global.t?.state.sgc_pageKey ?? -1,
                  i1z1i11m: _d_dats.d_flds.i1z1i11m ?? 0,
                  i1z1t21i: _d_dats.d_flds.i1z1t21i ?? 0,
                  i1z1i21i: _d_dats.d_flds.i1z1i21i ?? 0,
                  i1z1t22i: _d_dats.d_flds.i1z1t22i ?? 0,
                  i1z1i21m: _d_dats.d_flds.i1z1i21m ?? 0,
                  i1z1i31m: _d_dats.d_flds.i1z1i31m ?? 0,
                  i1z1i31d: _d_dats.d_flds.i1z1i31d ?? '',
                  i1z1i41d: _d_dats.d_flds.i1z1i41d ?? '',
                  i1z1t51i: _d_dats.d_flds.i1z1t51i ?? 10,
                  i1z1s11i: _d_dats.d_flds.i1z1s11i ?? 0,
                };
//ff.l('714: {}'.f(_d));
                return _d;
              },
            },
          },
        })
        .then(() => {
          _o_end1();
        });
      }),
      dd_cldDefss: {
        i1z0: {
          elm :'i1z0',
          b_setPageKey: false,
          od_insDats: _dd_datss => {
            let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
            let _d = {
              i1z0b31f: _d_i1zrs.d_flds.i1zrb31f ?? -1, // 親要素と同値
              i1z0b41f: _d_i1zrs.d_flds.i1zrb41f ?? -1, // 親要素と同値
              i1z0b51f: _dd_datss.i1z0.d_flds.i1z0b51f ?? -1,
              i1z0b61k: global.t?.state.sgc_pageKey ?? -1,
              i1z0i21d: _d_i1zrs.d_flds.i1zri21d ?? '', // 親要素と同値
              i1z0s11i: _d_i1zrs.d_flds.i1zrs11i ?? -1, // 親要素と同値
              i1z0i11m: _dd_datss.i1z0.d_flds.i1z0i11m ?? 0, // 不使用？
              i1z0i12m: _dd_datss.i1z0.d_flds.i1z0i12m ?? 0, // 不使用？
              i1z0i11i: 1,
              i1z0t11i: _d_i1zrs.d_flds.i1zrt41i ?? -1,
              i1z0i21s: _d_i1zrs.d_flds.i1zri41s ?? '',
              i1z0i31i: ff.n(_d_i1zrs.d_flds.i1zri41i) ?? 0,
            };
            return _d;
          },
          op_atrIns: _d_dats => new Promise( _o_end1 => { // 抽選対象への登録
//ff.l('714: {}'.f(_d));
            cf.myCB_callQrys({
              l_tgts: [
                'i1yri11i',
                'i1yri12i',
              ],
              d_vals: {
                i1yri11d: _d_dats.d_flds.i1z0i21d,
              },
            })
            .then(() => {
                  _o_end1();
            });
          }),
        },
        i1z2: {
          elm :'i1z2',
          b_setPageKey: false,
          od_insDats: _dd_datss => {
            let _d = {
              i1z2b41f: _dd_datss.i1z2.d_flds.i1z2b41f ?? -1,
              i1z2b61k: global.t?.state.sgc_pageKey ?? -1,
              i1z2i12m: _dd_datss.i1z2.d_flds.i1z2i12m,
            };
            return _d;
          },
        },
      },

    },
  },
  op_atrAll: () => new Promise( _o_end1 => {
//ff.l('i1zv 956: {}'.f(global.t?.state.sgc_pageFst))
//ff.l('i1zv 957: here');
    cf.myCB_callQrys({ // 暫定的に、毎回実行
      l_tgts: [
        'i1zrc11s', // ID
        'i1zri61s', // 団体名
        'i1zri62s', // 利用時間帯
      ],
      d_vals: {
        i1zr_fst: global.t?.state.sgc_pageFst
      },
    })
    .then(() => {
      cf.myCB_callQrys({ // 暫定的に、毎回実行
        l_tgts: [
          'i1z3i31i', // 予約数
        ],
        d_vals: {
          i1z3i21d: global.t?.state.sdld_i1zrDtlsss.i1zr[0].d_flds.i1zri21d,
        },
      })
      .then(() => {
        _o_end1();
      });

    });
  })
});


$clp_upds = () => [
  i1zv._updI1zrDtl(),
];

/*
static _eptPdf1 = (pl_i1zr_fst) => {

  if (pl_i1zr_fst) {

    cf.s();

    let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
    let _file = `利用申請書_${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`;
    let _ld_iss = []

    let _n_row = 0;
    _ld_iss.push({ type: 'text', pfx: `利用申請書`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1.2, b_bold: true });

    _n_row = 3;
    _ld_iss.push({ type: 'text', pfx: `ID: ${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
    _ld_iss.push({ type: 'text', pfx: `申込日: ${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri11d)}`,  n_cmn: 36, n_row: _n_row, n_cmnCnt: 19, aln: 'rht', n_rowCnt: 1, });

    _n_row = 5;
    String(global.t?.state.sgcd_stgs._01030100).split(/\n/).map( _frmMsg1 => {
      _ld_iss.push({ type: 'text', pfx: _frmMsg1,  n_cmn: 1, n_row: _n_row, ccd: global.t?.state.sgcd_stgs._01030101 });
      _n_row += 1;
    });

    _n_row += 1;
    _ld_iss.push({ type: 'text', pfx: `団体名`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc31s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
    _n_row += 1.5;
    _ld_iss.push({ type: 'text', pfx: `登録番号`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
    _n_row += 1.5;
    _ld_iss.push({ type: 'text', pfx: `申請者及び連絡先`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `申請者：${_d_i1zrs.d_flds.i1zri11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'left', b_frm: true });
    _ld_iss.push({ type: 'text', pfx: `連絡先：${_d_i1zrs.d_flds.i1zri12s}`,  n_cmn: 34, n_row: _n_row, n_cmnCnt: 21, n_rowCnt: 1.5, aln: 'left', b_frm: false });
    _n_row += 1.5;

    _n_row += 1;
    String(global.t?.state.sgcd_stgs._01030200).split(/\n/).map( _frmMsg2 => {
      _ld_iss.push({ type: 'text', pfx: _frmMsg2,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'ctr', ccd: global.t?.state.sgcd_stgs._01030201 });
      _n_row += 1;
    });

    _n_row += 1;
    _ld_iss.push({ type: 'text', pfx: `利用対象`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `利用日時`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    //_ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    //_ld_iss.push({ type: 'text', pfx: `貸出備品`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _n_row += 1;

    ff.myCM_getRng(4,1).map( _idx => {
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      //_ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      //_ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _n_row += 2;
    })

    _n_row += -8;
    _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => { // 室
      _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41s}`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 18, n_rowCnt: 1, aln: 'left', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41s}`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 1, aln: 'left', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${(_d_i1zrs.d_flds.i1zrt11i == 10) ? 'あり' : 'なし'}`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110i11t}:00〜${_d_i1z0s.d_flds.i110i12t}:00`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41i ?? '0'}人`,  n_cmn: 31, n_row: _n_row+1, n_cmnCnt: 17, n_rowCnt: 1, aln: 'rht', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${ff.n(_d_i1zrs.d_flds.i1zri41i) ?? '0'}人`,  n_cmn: 31, n_row: _n_row+1, n_cmnCnt: 24, n_rowCnt: 1, aln: 'rht', b_frm: false });
      _n_row += 2;
    })

    _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
      _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => {
        _ld_iss.push({ type: 'text', pfx: `${_d_i1z2s.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        //_ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 18, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        //_ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: false });
  //      _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110i11t}:00〜${_d_i1z0s.d_flds.i110i12t}:00`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        _n_row += 2;
      })
    })


    let _d_sums = {};
    let _ttlI1z0i11m = 0;

    _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室
      if (ff.f(_d_sums[_d_i1zrs.d_flds.i10rc11s]) == false) {
        _d_sums[_d_i1zrs.d_flds.i10rc11s] = {
          i10rc31s: _d_i1zrs.d_flds.i10rc31s,
          i10ri11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
          sumI1z0i11i: 1,
          sumI1z0i11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
        };
      }
      else{
        _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11i += 1;
        _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
      };
      _ttlI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
    });

    _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
      _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室

        let _n_hour = ff.n(_d_i1z0s.d_flds.i110i12t) - ff.n(_d_i1z0s.d_flds.i110i11t);

        if (ff.f(_d_sums[_d_i1z2s.d_flds.i10rc11s]) == false) {
          _d_sums[_d_i1z2s.d_flds.i10rc11s] = {
            i10rc31s: _d_i1z2s.d_flds.i10rc31s,
            i10ri11m: ff.n(_d_i1z2s.d_flds.i10ri11m),
            sumI1z0i11i: _n_hour,
            sumI1z0i11m: ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour,
          };
        }
        else{
          _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11i += _n_hour;
          _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
        };
        _ttlI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
      });
    });

    let _n_cnt = ff.myCM_getLen(_d_sums);

    if ( 
      _d_i1zrs.d_flds.i1zrt21i == '10' // 利用料の請求あり
    ) {

      _n_row += (4 - _n_cnt) * 2 + 1;
      _ld_iss.push({ type: 'text', pfx: `使用料`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 9, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
      _ld_iss.push({ type: 'text', pfx: `合計 ${ff.myCM_cnv('cmm', _ttlI1z0i11m)} 円`,  n_cmn: 44, n_row: _n_row, n_cmnCnt: 11, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, ccd: ic.o_getCcd('b'), backCcd: ic.o_getCcd('n') });

      Object.keys(_d_sums).map( _i10rc11s => {
        _ld_iss.push({ type: 'text', pfx: `${_d_sums[_i10rc11s].i10rc31s}`,  n_cmn: 10, n_row: _n_row, n_cmnCnt: 34, n_rowCnt: 1, aln: 'left', b_frm: true });
        _ld_iss.push({ type: 'text', pfx: `${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].i10ri11m ?? 0)} 円`,  n_cmn: 26, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `× ${_d_sums[_i10rc11s].sumI1z0i11i} 件`,  n_cmn: 32, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `＝ ${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].sumI1z0i11m)} 円`,  n_cmn: 38, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'rht', b_frm: false });
        _n_row += 1;
      })

      _n_row += 1;
      String(global.t?.state.sgcd_stgs._01030300).split(/\n/).map( _frmMsg3 => {
        _ld_iss.push({ type: 'text', pfx: _frmMsg3,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'left', ccd: global.t?.state.sgcd_stgs._01030301});
        _n_row += 1;
      });

    }

    if ( _n_cnt > 0 ) { // 利用料の請求あり
      _n_row = 39;
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 3});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 1});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 0, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: -10, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
      _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_ari.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
    }
    else {
      _n_row = 39;
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 3});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 1});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 0, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: -10, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
      _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_nashi.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
    }

    _ld_iss.push({ type: 'pstCvsToPdf' });
    _ld_iss.push({ type: 'savePdf' });

    myPD.myPD_dwlFile({
      file: _file,
      ld_iss: _ld_iss,
      d_inis: {
        orientation: 'portrait',
      },
    })
    .then(() => {
      cf.h();
    });


  }
  else {
    cf.s();

    let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
    let _file = `利用申請書_${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`;
    let _ld_iss = []

    let _n_row = 0;
    _ld_iss.push({ type: 'text', pfx: `利用申請書`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1.2, b_bold: true });

    _n_row = 3;
    _ld_iss.push({ type: 'text', pfx: `ID: ${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
    _ld_iss.push({ type: 'text', pfx: `申込日: ${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri11d)}`,  n_cmn: 36, n_row: _n_row, n_cmnCnt: 19, aln: 'rht', n_rowCnt: 1, });

    _n_row = 5;
    String(global.t?.state.sgcd_stgs._01030100).split(/\n/).map( _frmMsg1 => {
      _ld_iss.push({ type: 'text', pfx: _frmMsg1,  n_cmn: 1, n_row: _n_row, ccd: global.t?.state.sgcd_stgs._01030101 });
      _n_row += 1;
    });

    _n_row += 1;
    _ld_iss.push({ type: 'text', pfx: `団体名`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc31s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
    _n_row += 1.5;
    _ld_iss.push({ type: 'text', pfx: `登録番号`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
    _n_row += 1.5;
    _ld_iss.push({ type: 'text', pfx: `申請者及び連絡先`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `申請者：${_d_i1zrs.d_flds.i1zri11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'left', b_frm: true });
    _ld_iss.push({ type: 'text', pfx: `連絡先：${_d_i1zrs.d_flds.i1zri12s}`,  n_cmn: 34, n_row: _n_row, n_cmnCnt: 21, n_rowCnt: 1.5, aln: 'left', b_frm: false });
    _n_row += 1.5;

    _n_row += 1;
    String(global.t?.state.sgcd_stgs._01030200).split(/\n/).map( _frmMsg2 => {
      _ld_iss.push({ type: 'text', pfx: _frmMsg2,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'ctr', ccd: global.t?.state.sgcd_stgs._01030201 });
      _n_row += 1;
    });

    _n_row += 1;
    _ld_iss.push({ type: 'text', pfx: `利用対象`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `利用日時`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    //_ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    //_ld_iss.push({ type: 'text', pfx: `貸出備品`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _n_row += 1;

    ff.myCM_getRng(4,1).map( _idx => {
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      //_ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      //_ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _n_row += 2;
    })

    _n_row += -8;
    _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => { // 室
      _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41s}`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 18, n_rowCnt: 1, aln: 'left', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41s}`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 1, aln: 'left', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${(_d_i1zrs.d_flds.i1zrt11i == 10) ? 'あり' : 'なし'}`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110i11t}:00〜${_d_i1z0s.d_flds.i110i12t}:00`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      //_ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41i ?? '0'}人`,  n_cmn: 31, n_row: _n_row+1, n_cmnCnt: 17, n_rowCnt: 1, aln: 'rht', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${ff.n(_d_i1zrs.d_flds.i1zri41i) ?? '0'}人`,  n_cmn: 31, n_row: _n_row+1, n_cmnCnt: 24, n_rowCnt: 1, aln: 'rht', b_frm: false });
      _n_row += 2;
    })

    _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
      _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => {
        _ld_iss.push({ type: 'text', pfx: `${_d_i1z2s.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        //_ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 18, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        //_ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: false });
  //      _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110i11t}:00〜${_d_i1z0s.d_flds.i110i12t}:00`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        _n_row += 2;
      })
    })


    let _d_sums = {};
    let _ttlI1z0i11m = 0;

    _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室
      if (ff.f(_d_sums[_d_i1zrs.d_flds.i10rc11s]) == false) {
        _d_sums[_d_i1zrs.d_flds.i10rc11s] = {
          i10rc31s: _d_i1zrs.d_flds.i10rc31s,
          i10ri11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
          sumI1z0i11i: 1,
          sumI1z0i11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
        };
      }
      else{
        _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11i += 1;
        _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
      };
      _ttlI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
    });

    _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
      _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室

        let _n_hour = ff.n(_d_i1z0s.d_flds.i110i12t) - ff.n(_d_i1z0s.d_flds.i110i11t);

        if (ff.f(_d_sums[_d_i1z2s.d_flds.i10rc11s]) == false) {
          _d_sums[_d_i1z2s.d_flds.i10rc11s] = {
            i10rc31s: _d_i1z2s.d_flds.i10rc31s,
            i10ri11m: ff.n(_d_i1z2s.d_flds.i10ri11m),
            sumI1z0i11i: _n_hour,
            sumI1z0i11m: ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour,
          };
        }
        else{
          _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11i += _n_hour;
          _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
        };
        _ttlI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
      });
    });

    let _n_cnt = ff.myCM_getLen(_d_sums);

    if ( 
      _d_i1zrs.d_flds.i1zrt21i == '10' // 利用料の請求あり
    ) {

      _n_row += (4 - _n_cnt) * 2 + 1;
      _ld_iss.push({ type: 'text', pfx: `使用料`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 9, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
      _ld_iss.push({ type: 'text', pfx: `合計 ${ff.myCM_cnv('cmm', _ttlI1z0i11m)} 円`,  n_cmn: 44, n_row: _n_row, n_cmnCnt: 11, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, ccd: ic.o_getCcd('b'), backCcd: ic.o_getCcd('n') });

      Object.keys(_d_sums).map( _i10rc11s => {
        _ld_iss.push({ type: 'text', pfx: `${_d_sums[_i10rc11s].i10rc31s}`,  n_cmn: 10, n_row: _n_row, n_cmnCnt: 34, n_rowCnt: 1, aln: 'left', b_frm: true });
        _ld_iss.push({ type: 'text', pfx: `${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].i10ri11m ?? 0)} 円`,  n_cmn: 26, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `× ${_d_sums[_i10rc11s].sumI1z0i11i} 件`,  n_cmn: 32, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `＝ ${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].sumI1z0i11m)} 円`,  n_cmn: 38, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'rht', b_frm: false });
        _n_row += 1;
      })

      _n_row += 1;
      String(global.t?.state.sgcd_stgs._01030300).split(/\n/).map( _frmMsg3 => {
        _ld_iss.push({ type: 'text', pfx: _frmMsg3,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'left', ccd: global.t?.state.sgcd_stgs._01030301});
        _n_row += 1;
      });

    }

    if ( _n_cnt > 0 ) { // 利用料の請求あり
      _n_row = 39;
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 3});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 1});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 0, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: -10, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
      _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_ari.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
    }
    else {
      _n_row = 39;
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 3});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 1});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 0, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: -10, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
      _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_nashi.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
    }

    _ld_iss.push({ type: 'pstCvsToPdf' });
    _ld_iss.push({ type: 'savePdf' });

    myPD.myPD_dwlFile({
      file: _file,
      ld_iss: _ld_iss,
      d_inis: {
        orientation: 'portrait',
      },
    })
    .then(() => {
      cf.h();
    });
  };

};
*/

static _eptPdf1 = async (pd={
  name: null,
  l_fsts: null,
}) => {

//ff.l(pd);
//  if (ff.f(pd.l_fsts)) {
  if (ff.f(pd.name) && ff.f(pd.l_fsts)) {

    cf.s();
    let _ld_iss = []

//ff.l('I1zv 1372: {}'.f(pd));
    for await (const [_i1zrIdx, _i1zr_fst] of pd.l_fsts.entries()) {
//ff.l('I1zv 1377: {}, {}'.f(_i1zr_fst, _i1zrIdx));
      await i1zv.op_loadDtl({
        elm: 'i1zr',
        fst: _i1zr_fst,
      })
      .then( _d_is => {
//ff.l('I1zv 1381: {}'.f(_d_is));
        const _d_i1zrs = _d_is.i1zr[0];

        let _n_row = 0;
        _ld_iss.push({ type: 'text', pfx: `利用申請書`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1.2, b_bold: true });

        _n_row = 3;
        _ld_iss.push({ type: 'text', pfx: `ID: ${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
        _ld_iss.push({ type: 'text', pfx: `申込日: ${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri11d)}`,  n_cmn: 36, n_row: _n_row, n_cmnCnt: 19, aln: 'rht', n_rowCnt: 1, });

        _n_row = 5;
        String(global.t?.state.sgcd_stgs._01030100).split(/\n/).map( _frmMsg1 => {
          _ld_iss.push({ type: 'text', pfx: _frmMsg1,  n_cmn: 1, n_row: _n_row, ccd: global.t?.state.sgcd_stgs._01030101 });
          _n_row += 1;
        });

        _n_row += 1;
        _ld_iss.push({ type: 'text', pfx: `団体名`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc31s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
        _n_row += 1.5;
        _ld_iss.push({ type: 'text', pfx: `登録番号`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
        _n_row += 1.5;
        _ld_iss.push({ type: 'text', pfx: `申請者及び連絡先`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        _ld_iss.push({ type: 'text', pfx: `申請者：${_d_i1zrs.d_flds.i1zri11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'left', b_frm: true });
        _ld_iss.push({ type: 'text', pfx: `連絡先：${_d_i1zrs.d_flds.i1zri12s}`,  n_cmn: 34, n_row: _n_row, n_cmnCnt: 21, n_rowCnt: 1.5, aln: 'left', b_frm: false });
        _n_row += 1.5;

        _n_row += 1;
        String(global.t?.state.sgcd_stgs._01030200).split(/\n/).map( _frmMsg2 => {
          _ld_iss.push({ type: 'text', pfx: _frmMsg2,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'ctr', ccd: global.t?.state.sgcd_stgs._01030201 });
          _n_row += 1;
        });

        _n_row += 1;
        _ld_iss.push({ type: 'text', pfx: `利用対象`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        _ld_iss.push({ type: 'text', pfx: `利用日時`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        //_ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        _ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        //_ld_iss.push({ type: 'text', pfx: `貸出備品`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
        _n_row += 1;

        ff.myCM_getRng(4,1).map( _idx => {
          _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: true });
          _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 2, aln: 'ctr', b_frm: true });
          //_ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, n_rowCnt: 2, aln: 'ctr', b_frm: true });
          _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, n_rowCnt: 2, aln: 'ctr', b_frm: true });
          //_ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, n_rowCnt: 2, aln: 'ctr', b_frm: true });
          _n_row += 2;
        })

        _n_row += -8;
        _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => { // 室
          _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false, b_mln: true  });
          _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
          _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41s}`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 1, aln: 'left', b_frm: false });
          _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
          _ld_iss.push({ type: 'text', pfx: `${ff.n(_d_i1zrs.d_flds.i1zri41i) ?? '0'}人`,  n_cmn: 31, n_row: _n_row+1, n_cmnCnt: 24, n_rowCnt: 1, aln: 'rht', b_frm: false });
          _n_row += 2;
        })

        _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
          _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => {
            _ld_iss.push({ type: 'text', pfx: `${_d_i1z2s.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false, b_mln: true  });
            _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
            _ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 2, aln: 'ctr', b_frm: false });
            _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
            _n_row += 2;
          })
        })


        let _d_sums = {};
        let _ttlI1z0i11m = 0;

        _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室
          if (ff.f(_d_sums[_d_i1zrs.d_flds.i10rc11s]) == false) {
            _d_sums[_d_i1zrs.d_flds.i10rc11s] = {
              i10rc31s: _d_i1zrs.d_flds.i10rc31s,
              i10ri11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
              sumI1z0i11i: 1,
              sumI1z0i11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
            };
          }
          else{
            _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11i += 1;
            _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
          };
          _ttlI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
        });

        _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
//ff.l('1482: {}'.f(_d_i1z2s));
          _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室

            let _n_hour = ff.n(_d_i1z0s.d_flds.i110i12t) - ff.n(_d_i1z0s.d_flds.i110i11t);

            if (ff.f(_d_sums[_d_i1z2s.d_flds.i10rc11s]) == false) {
              _d_sums[_d_i1z2s.d_flds.i10rc11s] = {
                i10rc31s: _d_i1z2s.d_flds.i10rc31s,
                i10ri11m: ff.n(_d_i1z2s.d_flds.i10ri11m),
                sumI1z0i11i: _n_hour,
                sumI1z0i11m: ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour,
              };
            }
            else{
              _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11i += _n_hour;
              _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
            };
            _ttlI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
          });
        });

        let _n_cnt = ff.myCM_getLen(_d_sums);

        if ( 
          _d_i1zrs.d_flds.i1zrt21i == '10' // 利用料の請求あり
        ) {

          _n_row += (4 - _n_cnt) * 2 + 1;
          _ld_iss.push({ type: 'text', pfx: `使用料`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 9, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
          _ld_iss.push({ type: 'text', pfx: `合計 ${ff.myCM_cnv('cmm', _ttlI1z0i11m)} 円`,  n_cmn: 44, n_row: _n_row, n_cmnCnt: 11, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, ccd: ic.o_getCcd('b'), backCcd: ic.o_getCcd('n') });

          Object.keys(_d_sums).map( _i10rc11s => {
            _ld_iss.push({ type: 'text', pfx: `${_d_sums[_i10rc11s].i10rc31s}`,  n_cmn: 10, n_row: _n_row, n_cmnCnt: 34, n_rowCnt: 1, aln: 'left', b_frm: true });
            _ld_iss.push({ type: 'text', pfx: `${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].i10ri11m ?? 0)} 円`,  n_cmn: 24, n_row: _n_row, n_cmnCnt: 10, n_rowCnt: 1, aln: 'left', b_frm: false });
            _ld_iss.push({ type: 'text', pfx: `× ${_d_sums[_i10rc11s].sumI1z0i11i} 件`,  n_cmn: 32, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
            _ld_iss.push({ type: 'text', pfx: `＝ ${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].sumI1z0i11m)} 円`,  n_cmn: 34, n_row: _n_row, n_cmnCnt: 10, n_rowCnt: 1, aln: 'rht', b_frm: false });
            _n_row += 1;
          })

          _n_row += 1;
          String(global.t?.state.sgcd_stgs._01030300).split(/\n/).map( _frmMsg3 => {
            _ld_iss.push({ type: 'text', pfx: _frmMsg3,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'left', ccd: global.t?.state.sgcd_stgs._01030301});
            _n_row += 1;
          });

        }

        if ( _n_cnt > 0 ) { // 利用料の請求あり
          _n_row = 39;
          _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_ari.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
        }
        else {
          _n_row = 39;
          _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_nashi.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
        }

        _ld_iss.push({ type: 'pstCvsToPdf' });
        _ld_iss.push({ type: 'clrCvs' });
        if ( _i1zrIdx != ff.myCM_getLen(pd.l_fsts) - 1) {
          _ld_iss.push({ type: 'addNewPageToPdf' });
        }
      })
    }
//ff.l('I1zv 1376: here');

    _ld_iss.push({ type: 'savePdf' });

    let _name = pd.name;

    myPD.myPD_dwlFile({
      file: _name,
      ld_iss: _ld_iss,
      d_inis: {
        orientation: 'portrait',
      },
    })
    .then(() => {
      cf.h();
    });

  }
  else   if (ff.f(pd.name) && !ff.f(pd.l_fsts)) {
    alert('出力対象のデータが存在しません')
  }
  else { // 個別
    cf.s();

    let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
    let _file = `利用申請書_${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}_${ff.myDT_getDate('today').replace(/-/g, '')}.pdf`;
    let _ld_iss = []

    let _n_row = 0;
    _ld_iss.push({ type: 'text', pfx: `利用申請書`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 2, aln: 'ctr', b_frm: false, n_size: 1.2, b_bold: true });

    _n_row = 3;
    _ld_iss.push({ type: 'text', pfx: `ID: ${ff.myCM_pdd(_d_i1zrs.d_flds.i1zrc11s, 6, '0')}`,  n_cmn: 1, n_row: _n_row, n_rowCnt: 1, });
    _ld_iss.push({ type: 'text', pfx: `申込日: ${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri11d)}`,  n_cmn: 36, n_row: _n_row, n_cmnCnt: 19, aln: 'rht', n_rowCnt: 1, });

    _n_row = 5;
    String(global.t?.state.sgcd_stgs._01030100).split(/\n/).map( _frmMsg1 => {
      _ld_iss.push({ type: 'text', pfx: _frmMsg1,  n_cmn: 1, n_row: _n_row, ccd: global.t?.state.sgcd_stgs._01030101 });
      _n_row += 1;
    });

    _n_row += 1;
    _ld_iss.push({ type: 'text', pfx: `団体名`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc31s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
    _n_row += 1.5;
    _ld_iss.push({ type: 'text', pfx: `登録番号`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.c30rc11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'ctr', b_frm: true });
    _n_row += 1.5;
    _ld_iss.push({ type: 'text', pfx: `申請者及び連絡先`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 12, n_rowCnt: 1.5, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `申請者：${_d_i1zrs.d_flds.i1zri11s}`,  n_cmn: 13, n_row: _n_row, n_cmnCnt: 42, n_rowCnt: 1.5, aln: 'left', b_frm: true });
    _ld_iss.push({ type: 'text', pfx: `連絡先：${_d_i1zrs.d_flds.i1zri12s}`,  n_cmn: 34, n_row: _n_row, n_cmnCnt: 21, n_rowCnt: 1.5, aln: 'left', b_frm: false });
    _n_row += 1.5;

    _n_row += 1;
    String(global.t?.state.sgcd_stgs._01030200).split(/\n/).map( _frmMsg2 => {
      _ld_iss.push({ type: 'text', pfx: _frmMsg2,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'ctr', ccd: global.t?.state.sgcd_stgs._01030201 });
      _n_row += 1;
    });

    _n_row += 1;
    _ld_iss.push({ type: 'text', pfx: `利用対象`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `利用日時`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    //_ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 17, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _ld_iss.push({ type: 'text', pfx: `内容・利用人数`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    //_ld_iss.push({ type: 'text', pfx: `貸出備品`,  n_cmn: 48, n_row: _n_row, n_cmnCnt: 7, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
    _n_row += 1;

    ff.myCM_getRng(4,1).map( _idx => {
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _ld_iss.push({ type: 'text', pfx: ``,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 24, n_rowCnt: 2, aln: 'ctr', b_frm: true });
      _n_row += 2;
    })

    _n_row += -8;
    _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => { // 室　※ 室・設備で同様の設定
      _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false, b_mln: true });
      _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${_d_i1zrs.d_flds.i1zri41s}`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 1, aln: 'left', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
      _ld_iss.push({ type: 'text', pfx: `${ff.n(_d_i1zrs.d_flds.i1zri41i) ?? '0'}人`,  n_cmn: 31, n_row: _n_row+1, n_cmnCnt: 24, n_rowCnt: 1, aln: 'rht', b_frm: false });
      _n_row += 2;
    })

    _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
      _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => {
        _ld_iss.push({ type: 'text', pfx: `${_d_i1z2s.d_flds.i10rc31s}`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 16, n_rowCnt: 2, aln: 'ctr', b_frm: false, b_mln: true });
        _ld_iss.push({ type: 'text', pfx: `${ff.myDT_cnv('西暦月日', _d_i1zrs.d_flds.i1zri21d)}`,  n_cmn: 17, n_row: _n_row, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `-`,  n_cmn: 31, n_row: _n_row, n_cmnCnt: 25, n_rowCnt: 2, aln: 'ctr', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `${_d_i1z0s.d_flds.i110c31s}`,  n_cmn: 17, n_row: _n_row+1, n_cmnCnt: 14, n_rowCnt: 1, aln: 'ctr', b_frm: false });
        _n_row += 2;
      })
    })


    let _d_sums = {};
    let _ttlI1z0i11m = 0;

    _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室
      if (ff.f(_d_sums[_d_i1zrs.d_flds.i10rc11s]) == false) {
        _d_sums[_d_i1zrs.d_flds.i10rc11s] = {
          i10rc31s: _d_i1zrs.d_flds.i10rc31s,
          i10ri11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
          sumI1z0i11i: 1,
          sumI1z0i11m: bf.n(_d_i1zrs.d_flds.i10ri11m),
        };
      }
      else{
        _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11i += 1;
        _d_sums[_d_i1zrs.d_flds.i10rc11s].sumI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
      };
      _ttlI1z0i11m += bf.n(_d_i1zrs.d_flds.i10ri11m);
    });

    _d_i1zrs.dld_cldDatsss?.i1z2.map( _d_i1z2s => { // 設備
      _d_i1zrs.dld_cldDatsss?.i1z0.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => { //室

        let _n_hour = ff.n(_d_i1z0s.d_flds.i110i12t) - ff.n(_d_i1z0s.d_flds.i110i11t);

        if (ff.f(_d_sums[_d_i1z2s.d_flds.i10rc11s]) == false) {
          _d_sums[_d_i1z2s.d_flds.i10rc11s] = {
            i10rc31s: _d_i1z2s.d_flds.i10rc31s,
            i10ri11m: ff.n(_d_i1z2s.d_flds.i10ri11m),
            sumI1z0i11i: _n_hour,
            sumI1z0i11m: ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour,
          };
        }
        else{
          _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11i += _n_hour;
          _d_sums[_d_i1z2s.d_flds.i10rc11s].sumI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
        };
        _ttlI1z0i11m += ff.n(_d_i1z2s.d_flds.i10ri11m) * _n_hour;
      });
    });

    let _n_cnt = ff.myCM_getLen(_d_sums);

    if ( 
      _d_i1zrs.d_flds.i1zrt21i == '10' // 利用料の請求あり
    ) {

      _n_row += (4 - _n_cnt) * 2 + 1;
      _ld_iss.push({ type: 'text', pfx: `使用料`,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 9, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, backCcd: ic.o_getCcd('h') });
      _ld_iss.push({ type: 'text', pfx: `合計 ${ff.myCM_cnv('cmm', _ttlI1z0i11m)} 円`,  n_cmn: 44, n_row: _n_row, n_cmnCnt: 11, n_rowCnt: _n_cnt, aln: 'ctr', b_frm: true, ccd: ic.o_getCcd('b'), backCcd: ic.o_getCcd('n') });

      Object.keys(_d_sums).map( _i10rc11s => {
/*
        _ld_iss.push({ type: 'text', pfx: `${_d_sums[_i10rc11s].i10rc31s}`,  n_cmn: 10, n_row: _n_row, n_cmnCnt: 34, n_rowCnt: 1, aln: 'left', b_frm: true });
        _ld_iss.push({ type: 'text', pfx: `${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].i10ri11m ?? 0)} 円`,  n_cmn: 26, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `× ${_d_sums[_i10rc11s].sumI1z0i11i} 件`,  n_cmn: 32, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `＝ ${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].sumI1z0i11m)} 円`,  n_cmn: 38, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'rht', b_frm: false });
*/
        _ld_iss.push({ type: 'text', pfx: `${_d_sums[_i10rc11s].i10rc31s}`,  n_cmn: 10, n_row: _n_row, n_cmnCnt: 34, n_rowCnt: 1, aln: 'left', b_frm: true });
        _ld_iss.push({ type: 'text', pfx: `${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].i10ri11m ?? 0)} 円`,  n_cmn: 24, n_row: _n_row, n_cmnCnt: 10, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `× ${_d_sums[_i10rc11s].sumI1z0i11i} 件`,  n_cmn: 32, n_row: _n_row, n_cmnCnt: 6, n_rowCnt: 1, aln: 'left', b_frm: false });
        _ld_iss.push({ type: 'text', pfx: `＝ ${ff.myCM_cnv('cmm', _d_sums[_i10rc11s].sumI1z0i11m)} 円`,  n_cmn: 34, n_row: _n_row, n_cmnCnt: 10, n_rowCnt: 1, aln: 'rht', b_frm: false });
        _n_row += 1;
      })

      _n_row += 1;
      String(global.t?.state.sgcd_stgs._01030300).split(/\n/).map( _frmMsg3 => {
        _ld_iss.push({ type: 'text', pfx: _frmMsg3,  n_cmn: 1, n_row: _n_row, n_cmnCnt: 54, n_rowCnt: 1, aln: 'left', ccd: global.t?.state.sgcd_stgs._01030301});
        _n_row += 1;
      });

    }

    if ( _n_cnt > 0 ) { // 利用料の請求あり
      _n_row = 39;
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 3});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 1});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: 0, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: -10, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image3.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
      _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_ari.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
    }
    else {
      _n_row = 39;
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 3});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 5, n_row: _n_row, n_rowCnt: 1});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: 0, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: -10, n_row: _n_row, n_rowCnt: 7});
  //    _ld_iss.push({ type: 'img', url: `${ic.g_url2}/image4.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
      _ld_iss.push({ type: 'img', url: `${ic.g_url2}/${myWB.myWB_getDmn().subDmn}/shinsei_nashi.png`,  n_x: -7, n_row: _n_row, n_rowCnt: 7});
    }

    _ld_iss.push({ type: 'pstCvsToPdf' });
    _ld_iss.push({ type: 'savePdf' });

    myPD.myPD_dwlFile({
      file: _file,
      ld_iss: _ld_iss,
      d_inis: {
        orientation: 'portrait',
      },
    })
    .then(() => {
      cf.h();
    });
  };

};


_eptExl1a = async () => { // 予約一覧

  cf.s();

  const _ld_hdrss = [
    { key:  1, header: '予約ID', width: 20, style: {} },
    { key:  2, header: '状況', width: 20, style: {} },
    { key:  3, header: '申込日', width: 20, style: {} },
    { key:  4, header: '団体番号', width: 20, style: {} },
    { key:  5, header: '団体名', width: 20, style: {} },
    { key:  6, header: '代表者', width: 20, style: {} },
    { key:  7, header: '利用制限', width: 20, style: {} },
    { key:  8, header: '申込者', width: 20, style: {} },
    { key:  9, header: '連絡先', width: 20, style: {} },
    { key: 10, header: '内容', width: 20, style: {} },
    { key: 11, header: '人数', width: 20, style: {} },
    { key: 12, header: '貸出備品', width: 20, style: {} },
    { key: 13, header: '利用室', width: 20, style: {} },
    { key: 14, header: '利用設備', width: 20, style: {} },
    { key: 15, header: '利用日', width: 20, style: {} },
    { key: 16, header: '利用時間帯', width: 20, style: {} },
    { key: 17, header: '利用料計', width: 20, style: {} },
    { key: 18, header: '減免率区分', width: 20, style: {} },
    { key: 19, header: '減免率', width: 20, style: {} },
    { key: 20, header: '減免額計', width: 20, style: {} },
    { key: 21, header: '支払額計', width: 20, style: {} },
    { key: 22, header: '支払期限', width: 20, style: {} },
    { key: 23, header: '支払日', width: 20, style: {} },
    { key: 24, header: '支払状況', width: 20, style: {} },
  ];

  let _ld_bdyss = [];
  for await (let [_i1zrIdx, _d_i1zrSlcs] of ff.e(global.t?.state.sdld_i1zrSlcListsss.i1zr)) {
    await i1zv.op_loadDtl({
      elm :'i1zr',
      fst: _d_i1zrSlcs.d_flds._fst,
    })
    .then(() => {
      let _d_i1zrDtls = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
      let _i1z0b51f = '';
      _d_i1zrDtls.dld_cldDatsss.i1z0.map(_d_i1z0s => {
        _i1z0b51f += ((ff.f(_i1z0b51f) == true) ? '・' : '') + cf.myRN_cnvFldVal(_d_i1z0s, 'i1z0b51f', global.t?.state.sdld_i110SlcListsss?.i110);
      });
      let _i1z2b41f = '';
      _d_i1zrDtls.dld_cldDatsss.i1z2.map(_d_i1z2s => {
        _i1z2b41f += ((ff.f(_i1z2b41f) == true) ? '・' : '') + _d_i1z2s.d_flds.i10rc31s;
      });
      _ld_bdyss.push({
        1: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zrc11s'),
        2: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zrs11i'),
        3: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri11d'),
        4: cf.myRN_cnvFldVal(_d_i1zrDtls, 'c30rc11s'),
        5: cf.myRN_cnvFldVal(_d_i1zrDtls, 'c30rc31s'),
        6: cf.myRN_cnvFldVal(_d_i1zrDtls, 'c30ri11s'),
        7: cf.myRN_cnvFldVal(_d_i1zrDtls, 'c30ri21s'),
        8: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri11s'),
        9: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri12s'),
       10: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri41s'),
       11: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri41i'),
       12: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zrt41i'),
       13: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zrb41f', global.t?.state.sdld_i10rSlcListsss?.i10r),
//       14: '',　// 利用設備
       14: _i1z2b41f,　// 利用設備
       15: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri21d'),
       16: _i1z0b51f,　// 利用時間帯
       17: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1zri11m'),
       18: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1t21i'),
       19: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1i21i'),
       20: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1i21m'),
       21: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1i31m'),
       22: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1i31d'),
       23: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1i41d'),
       24: cf.myRN_cnvFldVal(_d_i1zrDtls, 'i1z1s11i'),
      });
    });
  };

  myXL.myXL_dwlFile({
    file: `予約一覧_${ff.myDT_getDate('today').replace(/-/g, '')}.xlsx`,
    sht: 'sheet1',
    ld_hdrss: _ld_hdrss,
    ld_bdyss: _ld_bdyss,
  })
  .then(() => {
    cf.h();
  });

};

//_b_nowChgI1zrb31f = false; // 団体情報の反映中は登録不可

_op_onChgI1zrb31f = (pd={ // 団体情報の反映
  i1zrb31f: null,
}) => new Promise( _o_end1 => { 
  if (pd.i1zrb31f > 0) {
/*
ff.l('I1zv 1797: here');
    if (global.t) global.t._b_nowChgI1zrb31f = true;
ff.l('I1zv 1799: here');
*/
    cf.s();
    c20v1a.op_loadDtl({
      elm: 'c20r',
      c30r_fst: pd.i1zrb31f,
    })
    .then(() => {
      c30v1a.op_loadDtl({
        elm: 'c30r',
        fst: pd.i1zrb31f,
      })
      .then(() => {
        let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0]; 
        let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0]; 
        cf.myRN_setDat('sdld_i1zrDtlsss', _d_i1zrs, _d_dats => {
          let _d = {
            i1zrt21i: _d_c30rs.d_flds.i15rt11i, // 利用料の請求
            i1z1t21i: _d_c30rs.d_flds.c30rt21i, // 減免率区分
            i1z1i21i: _d_c30rs.d_flds.c30ri22i, // 減免率
            i1z1t22i: _d_c30rs.d_flds.c30rt22i, // 減免理由
            i1zri31s: _d_c30rs.d_flds.c30ri11s, // 代表者
            i1zri32s: _d_c30rs.d_flds.c30ri21s, // 利用制限
            i1zri11s: _d_c30rs.d_flds.c30ri11s, // 申込者
            i1zri12s: _d_c30rs.d_flds.c30ri41s, // 連絡先
          };
          return _d;
        })
        .then(() => {
          global.t?._op_updI1z1i31m()
          .then(() => {
            cf.h();
/*
ff.l('I1zv 1830: here');
            if (global.t) global.t._b_nowChgI1zrb31f = false;
ff.l('I1zv 1832: here');
*/
            _o_end1();
          });
        });                         
      })
    })
  }
  else {
    _o_end1();
  };
});

_op_updI1z1i31m = (pd={}) => new Promise( _o_end1 => { // 支払額計の更新
  cf.myRN_setDat('sdld_i1zrDtlsss', global.t?.state.sdld_i1zrDtlsss.i1zr[0], _d_dats => {
    let _n_cnt = ff.myCM_getLen(_d_dats.dld_cldDatsss?.i1z0?.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true && _d_i1z0s.d_flds.i1z0b51f > 0) ? true : false)); // コマ数
    let _i1zri11m = 0;
    _i1zri11m += cf.myRN_getFldVal(_d_dats, 'i1zrb41f', 'i10ri11m', 'i10ri11m') * _n_cnt;
    _d_dats?.dld_cldDatsss?.i1z2?.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true && _d_i1z2s.d_flds.i1z2b41f > 0) ? true : false)
    .map( _d_i1z2s => {
      _d_dats?.dld_cldDatsss?.i1z0?.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false).map( _d_i1z0s => {
        let _n_hour = ff.n(_d_i1z0s.d_flds.i110i12t) - ff.n(_d_i1z0s.d_flds.i110i11t);
        _i1zri11m += ff.n(_d_i1z2s.d_flds.i1z2i12m) * _n_hour;
      })
    });
    let _i1z1i21i = (_d_dats.d_flds.i1z1t21i == 999) ? _d_dats.d_flds.i1z1i21i : _d_dats.d_flds.i1z1t21i;
    let _i1z1i21m = ff.myCM_cnv('ceil', _i1zri11m * _i1z1i21i / 100);
    let _i1z1i31m = _i1zri11m - _i1z1i21m;
    let _i1z1i31d = null;
    if (global.t?.state.sgcd_stgs._01040500 == '10' && _d_dats.d_flds.i1zri21d) { // 利用日基準
      _i1z1i31d = ff.myDT_add('day', _d_dats.d_flds.i1zri21d, -1 * ff.n(global.t?.state.sgcd_stgs._01040600));
    }
    if (global.t?.state.sgcd_stgs._01040500 == '20' && _d_dats.d_flds.i1zri11d) { // 申請日基準
      _i1z1i31d = ff.myDT_add('day', _d_dats.d_flds.i1zri11d, +1 * ff.n(global.t?.state.sgcd_stgs._01040600));
    }
    return {
      i1zri11m: _i1zri11m,
      i1z1i21m: _i1z1i21m,
      i1z1i31m: _i1z1i31m,
      i1z1i31d: _i1z1i31d,
    };
  })
  .then(() => {
    _o_end1();
  });
});

_o_rdrFly = () => { // 直接予約用

  let _r2 = [];
  let _n_cnt = 0;

  let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss?.i1zr[0];
//  if (_d_i1zrs) _d_i1zrs?.dld_cldDatsss?.i1z2?.map( (_d_i1z2s, _idx) => {
  if (_d_i1zrs) _d_i1zrs?.dld_cldDatsss?.i1z2?.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true)).map( (_d_i1z2s, _idx) => {
      _n_cnt += 1;
      _r2.push(
        ce.c(ce.Pck, {
          key: _idx,
          pfx: (_n_cnt > 1 ) ? '' : '備品・駐車場',
          b_edit: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
          b_row: true,
          n_col: 10,
          d_stlInps: {
            marginLeft: (_n_cnt > 1) ? ic.m(1) : 0,
          },
          d_lbls: {
            n_w: ( _n_cnt > 1 ) ? 0 : ic.s(6),
          },
          ld_iss: global.t?.state.sdld_i10rSlcListsss2?.i10r,
          ini: _d_i1z2s.d_flds.i1z2b41f,
          o_onChgAsCld: _d_dats => {
            cf.myRN_setDat('sdld_i1zrDtlsss', _d_i1z2s, _d_nexts => {
              let _d = {
                'i10r_key': _d_dats.d_flds._key,
                'i10r_fst': _d_dats.d_flds._fst,
                ..._d_dats.d_flds,
                '_fst': null,
                '_key': null,
                i1z2b41f: _d_dats.d_flds._fst,
                i1z2i12m: _d_dats.d_flds.i10ri11m,
              };
              return _d;
            })
            .then(() => {
              global.t?._op_loadCdrList2({
                state1: `sdld_cdrListsss2`,
                state2: `sl_dates2`,
                date: global.t?.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
              })
              .then(() => {
                global.t?._op_updI1z1i31m(); // 支払額の計算             
              });
            });
          },
          o_onClrPrsAsCld: () => {
            cf.myRN_setStt({
              sdld_i1zrDtlsss: _d_nexts => {
                let _d_crrDats = cf.myRN_getDat(_d_nexts, _d_i1z2s.ld_arsss);
                _d_crrDats.b_dlt = true;
              },
            })
            .then(() => {
              global.t?._op_loadCdrList2({
                state1: `sdld_cdrListsss2`,
                state2: `sl_dates2`,
                date: global.t?.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
              })
              .then(() => {
                global.t?._op_updI1z1i31m(); // 支払額の計算             
              });
            });
          },
          b_clr: true,
        })
      );
  })

  if (ff.i(global.t?.state.sgc_pageMode, ['new', 'edit'])) {
    _r2.push(
      ce.c(ce.Pck, {
        key: 'new',
        state: 's_fly',
//        pfx: ff.myCM_getLen(_d_i1zrs?.dld_cldDatsss?.i1z2) > 0 ? '' : '併用設備',
//        pfx: ff.myCM_getLen(_d_i1zrs?.dld_cldDatsss?.i1z2) > 0 ? '' : '備品・駐車場',
        pfx: ff.myCM_getLen(_d_i1zrs?.dld_cldDatsss?.i1z2?.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true))) > 0 ? '' : '備品・駐車場',
        b_edit: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
        b_row: true,
        n_col: 10,
        d_stlInps: {
          marginLeft: ff.myCM_getLen(_d_i1zrs?.dld_cldDatsss?.i1z2) > 0 ? ic.m(1) : 0,
        },
        d_lbls: {
//          n_w: ff.myCM_getLen(_d_i1zrs?.dld_cldDatsss?.i1z2) > 0 ? 0 : ic.s(5),
          n_w: ff.myCM_getLen(_d_i1zrs?.dld_cldDatsss?.i1z2) > 0 ? 0 : ic.s(6),
        },
        ld_iss: global.t?.state.sdld_i10rSlcListsss2?.i10r,
        o_onChg: _d_i10rs => {
          if (_d_i10rs) { // 削除された場合を考慮
            let _d_insDats = cf.myRN_crtDats({
              elm: 'i1z2',
              d_insFlds: {
                'i10r_key': _d_i10rs.d_flds._key,
                'i10r_fst': _d_i10rs.d_flds._fst,
                ..._d_i10rs.d_flds,
                '_fst': null,
                '_key': null,
                ...cf.e('i1z2').d_insFlds,
                i1z2b41f: _d_i10rs.d_flds._fst,
                i1z2i12m: _d_i10rs.d_flds.i10ri11m,
              },
            });
            cf.myRN_addDats({ // 要素の追加
              state: 'sdld_i1zrDtlsss',
              als: 'i1z2',
              d_dats: _d_insDats,
              d_prtDats: _d_i1zrs,
            })
            .then(() => {
              cf.myRN_setStt({ // 表示の初期化
                s_fly: -1,
              })
              .then(() => {
                global.t?._op_loadCdrList2({
                  state1: `sdld_cdrListsss2`,
                  state2: `sl_dates2`,
                  date: global.t?.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                })
                .then(() => {
                  global.t?._op_updI1z1i31m(); // 支払額の計算             
                });
              });
            });
          }
        },
      })
    );
  };

  return _r2;

}

_o_rdrFly2 = () => { // 一括登録用

  let _r2 = [];

//  let _ld_i1z2ss = global.t?.state.sdld_i1z2Listsss?.i1z2 ?? [];
  let _ld_i1z2ss = global.t?.state.sdld_i1z2Listsss?.i1z2?.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true)) ?? [];

//  if (ff.f(_ld_i1z2ss)) _ld_i1z2ss.filter( _d_i1z2s => (_d_i1z2s.b_dlt != true)).map( (_d_i1z2s, _idx) => {
  if (ff.f(_ld_i1z2ss)) _ld_i1z2ss.map( (_d_i1z2s, _idx) => {
      _r2.push(
        ce.c(ce.Pck, {
          key: _idx,
//          pfx: (_idx > 0) ? '' : '併用設備',
          pfx: (_idx > 0) ? '' : '備品・駐車場',
          b_edit: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
          b_row: true,
          n_col: 10,
          d_stlInps: {
            marginLeft: (_idx > 0) ? ic.m(1) : 0,
          },
          d_lbls: {
//            n_w: (_idx > 0) ? 0 : ic.s(5),
            n_w: (_idx > 0) ? 0 : ic.s(6),
          },
          ld_iss: global.t?.state.sdld_i10rSlcListsss2?.i10r,
          ini: _d_i1z2s.d_flds.i1z2b41f,
          o_onChgAsCld: _d_dats => {
            cf.myRN_setDat('sdld_i1z2Listsss', _d_i1z2s, _d_nexts => {
              let _d = {
                'i10r_key': _d_dats.d_flds._key,
                'i10r_fst': _d_dats.d_flds._fst,
                ..._d_dats.d_flds,
                '_fst': null,
                '_key': null,
                i1z2b41f: _d_dats.d_flds._fst,
                i1z2i12m: _d_dats.d_flds.i10ri11m,
              };
              return _d;
            })
            .then(() => { // 要修正
              global.t?._op_loadCdr(); // 予約状況の更新
            });
          },

          o_onClrPrsAsCld: () => {
//ff.l('I1zv 2095: {}'.f(_d_i1z2s));
//ff.l('I1zv 2097: {}'.f(_d_i1z2s.ld_arsss));
//ff.l('I1zv 2097: {}'.f(cf.myRN_getDat(global.t?.state.sdld_i1z2Listsss, _d_i1z2s.ld_arsss)));
            cf.myRN_setStt({
              sdld_i1z2Listsss: _next => {
                const _d_crrDats = cf.myRN_getDat(_next, _d_i1z2s.ld_arsss);
                _d_crrDats.b_dlt = true;
              },
            })
            .then(() => {
//ff.l('I1zv 2101: {}'.f(global.t?.state.sdld_i1z2Listsss));
//ff.l('I1zv 2102: {}'.f(_d_i1z2s));
/*
              global.t?._op_loadCdrList2({
                state1: `sdld_cdrListsss2`,
                state2: `sl_dates2`,
                date: global.t?.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
              })
              .then(() => {
                global.t?._op_updI1z1i31m(); // 支払額の計算             
              });
*/
              global.t?._op_loadCdr(); // 予約状況の更新
            });
          },
          b_clr: true,

        })
      );
  })

  if (ff.i(global.t?.state.sgc_pageMode, ['new', 'edit'])) {
    _r2.push(
      ce.c(ce.Pck, {
        key: 'new',
        state: 's_fly',
        pfx: ff.myCM_getLen(_ld_i1z2ss) > 0 ? '' : '備品・駐車場',
        b_edit: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
        b_row: true,
        n_col: 10,
        d_stlInps: {
          marginLeft: ff.myCM_getLen(_ld_i1z2ss) > 0 ? ic.m(1) : 0,
        },
        d_lbls: {
          n_w: ff.myCM_getLen(_ld_i1z2ss) > 0 ? 0 : ic.s(6),
        },
        ld_iss: global.t?.state.sdld_i10rSlcListsss2?.i10r,
        o_onChg: _d_i10rs => {
          if (_d_i10rs) { // 削除された場合を考慮
            let _d_insDats = cf.myRN_crtDats({
              elm: 'i1z2',
              d_insFlds: {
                'i10r_key': _d_i10rs.d_flds._key,
                'i10r_fst': _d_i10rs.d_flds._fst,
                ..._d_i10rs.d_flds,
                '_fst': null,
                '_key': null,
                ...cf.e('i1z2').d_insFlds,
                i1z2b41f: _d_i10rs.d_flds._fst,
                i1z2i12m: _d_i10rs.d_flds.i10ri11m,
              },
            });
            cf.myRN_addDats({ // 要素の追加
              state: 'sdld_i1z2Listsss',
              als: 'i1z2',
              d_dats: _d_insDats, // d_prtDats は不要
            })
            .then(() => {
              cf.myRN_setStt({ // 表示の初期化
                s_fly: -1,
              })
              .then(() => { // 要修正
                global.t?._op_loadCdr(); // 予約状況の更新
/*
                global.t?._op_loadCdrList2({
                  state1: `sdld_cdrListsss2`,
                  state2: `sl_dates2`,
                  date: global.t?.state.sdld_i1zrDtlsss?.i1zr[0].d_flds.i1zri21d,
                })
                .then(() => {
                  global.t?._op_updI1z1i31m(); // 支払額の計算             
                });
*/
              });
            });
          }
        },
      })
    );
  };

  return _r2;

}
// check 処理と render は個別に記述

_o_rdrTime = () => {
  let _r = [];
  global.t?.state.sdld_i110SlcListsss?.i110.map( (_d_i110s, _i110Idx) => { // 時間帯の設定
    _r.push(
      ce.c(ce.Chk, {
        key: _i110Idx,
        frm: 'sqr',
        bsd: _d_i110s.d_flds.i110c31s,
        state: `s_time${_d_i110s.d_flds._fst}`,
        b_edit: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']),
        b_row: true,
        n_col: 5,
        o_onChg: _n_chk => {          
          new Promise( _o_end1 => {
            let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
            if ( _n_chk  == 1 ) { //　チェックされた場合
              let _b_est = false;
              let _b_dlt = false;
              _d_i1zrs.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
                if (_d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                  _b_est = true;
                  if ( _d_i1z0s.b_dlt == true ) { // 削除済の場合
                    _b_dlt = true;
                  }; 
                };
              });
              if ( _b_est == false ) { // i1z0 が存在しない場合：　追加
                let _d_i1z0Dats = cf.myRN_crtDats({
                  elm: 'i1z0',
                  d_insFlds: {
                    i1z0b51f: _d_i110s.d_flds._fst ?? -1,
                    i110i11t: _d_i110s.d_flds.i110i11t ?? '',
                    i110i12t: _d_i110s.d_flds.i110i12t ?? '',
                    i110cx1i: _d_i110s.d_flds.i110cx1i ?? '',
                  },
                });
                cf.myRN_addDats({
                  state: 'sdld_i1zrDtlsss',
                  als: 'i1z0',
                  d_dats: _d_i1z0Dats,
                  d_prtDats: _d_i1zrs,
                })
                .then(_o_end1);
              };
              if ( _b_est == true ) { // i1z0 が存在する場合：　更新
                if ( _b_dlt == true ) { // 削除済の i1z0 の場合
                  cf.myRN_setStt({
                    sdld_i1zrDtlsss: _next => {
                      let _d_crrDats = cf.myRN_getDat(_next, _d_i1zrs.ld_arsss);
                      _d_crrDats.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
                        if (_d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                          if ( _d_i1z0s.b_dlt == true ) { // 削除済の場合
                            _d_i1z0s.b_dlt = false;
                          }; 
                        };
                      });
                    }
                  })
                  .then(_o_end1);
                }
                else {
                  // 何もしない
                  _o_end1();
                };
              };
            };
            if ( _n_chk  == 0 ) { //　チェックが解除された場合
              cf.myRN_setStt({
                sdld_i1zrDtlsss: _next => {
                  let _d_crrDats = cf.myRN_getDat(_next, _d_i1zrs.ld_arsss);
                  _d_crrDats.dld_cldDatsss?.i1z0?.map( _d_i1z0s => {
                    if (_d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {
                      _d_i1z0s.b_dlt = true;
                    };
                  });
                }
              })
              .then(_o_end1)
            };
          })
          .then(() => {
            global.t?._op_updI1z1i31m() // 利用料の更新
            .then(() => {
              global.t?._op_updI1zrs11i(); // 予約状況の更新
            }); // 支払額の更新
          });
        }
      }),
    );
//ff.l('1399: here');
  });
//ff.l('1400: here');
  return _r;
};

_op_updI1zrs11i = (pd={}) => new Promise( _o_end1 => { // 予約状況の更新
  let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
  if (ff.i(global.t?.d_viewDefs.class, ['i1zv1a', 'i1zv2a'])) { // 直接予約の場合のみ更新
    cf.myRN_setDat('sdld_i1zrDtlsss', _d_i1zrs, _d_dats => {
      let _i1zrs11i = 0;
      if (
        _d_dats.d_flds.i1zrb41f > 0 &&
        ff.f(_d_dats.d_flds.i1zri21d) &&
        ff.myCM_getLen(_d_dats.dld_cldDatsss?.i1z0?.filter( _d_i1z0s => (_d_i1z0s.b_dlt != true) ? true : false)) > 0
      ) { // 室・利用日・時間帯が指定されている
        _i1zrs11i = 70;
        if (_d_dats.d_flds.i1zrb31f > 0) { // 団体が指定されている
          _i1zrs11i = 80;
          if (ff.f(_d_dats.d_flds.i1z1i41d)) { // 支払日が設定されている
            _i1zrs11i = 90;
          };
        };
      }; 
      //ff.l('i1zv1 59: {}, {}, {}, {}'.f(_i1zrs11i, _d_dats.d_flds.i1zrb41f, _d_dats.d_flds.i1zri21d, ff.myCM_getLen(_d_dats.dld_cldDatsss?.i1z0?.filter( _d_i1z0s => _d_i1z0s.b_dlt != true ? true : false))))
      return {
        i1zrs11i: _i1zrs11i,
      };
    })
    .then(_o_end1);
  }
  else {
    _o_end1();
  };
});

$clp_dlts = () => 
  [
    new Promise( _o_end1 => {
      let _d_i1zrs = global.t?.state.sdld_i1zrDtlsss.i1zr[0];
      cf.myRN_setDat('sdld_i1zrDtlsss', _d_i1zrs, _d_i1zrs => {
        let _d = {
          i1zrcz1i: 0,
        };
        return _d;
      })
      .then(() => {
        Promise.all(global.t?.$clp_upds())
        .then(_o_end1);
      });
    }),
  ]
;

static op_chkSglI10r = (pd={
  d_i1zrs: null,
  pageMode: null,
}) => new Promise( _o_end1 => {
  let _d_i1zrs = pd.d_i1zrs;
  let _rsvRoom = _d_i1zrs.d_flds.i1zrb41f;
  let _rsvDate = _d_i1zrs.d_flds.i1zri21d;
  let _n_rsvMaxCnt = _d_i1zrs.d_flds.i10ri11i;
  let _b_sgl = true;
  Promise.all(_d_i1zrs.dld_cldDatsss.i1z0
  .filter( _d_i1z0s => _d_i1z0s.b_dlt != true ? true : false)
  .map( async _d_i1z0s => {
    let _rsvTime = _d_i1z0s.d_flds.i1z0b51f;
    await i1zv.op_loadSlcList({
      elm: 'i1z0',
      o_cnd: _dd_datss => {
//        let _cnd = `t_i1z0.i1z0b41f = ${_rsvRoom} AND t_i1z0.i1z0b51f = ${_rsvTime} AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
        let _cnd = `t_i1z0.i1z0b51f = ${_rsvTime} AND EXISTS ( SELECT * FROM t_i1zr WHERE _key = t_i1z0.i1z0b61k AND i1zrb41f = ${_rsvRoom} AND i1zri21d = "${_rsvDate}" AND i1zrs11i IN (70, 80, 90) AND t_i1zr._vsn = t_i1zr._ltt)`;
        if (pd.pageMode == 'edit') {
          _cnd += ` AND t_i1z0.i1z0b61k NOT IN (SELECT t_i1zr._key FROM t_i1zr WHERE {})`.f(cf.c('i1zr', `t_i1zr._fst = ${_d_i1zrs.d_flds._fst}`)); // 自身以外の件数
        };
        _cnd = cf.c('i1z0', _cnd);
        //ff.l('i1zv 1504: {}'.f(_cnd));
        return _cnd;
      },
    })
    .then(() => {
      let _n_cnt = ff.myCM_getLen(global.t?.state.sdld_i1z0SlcListsss.i1z0);
      //ff.l('i1zv 1513: {}, {}, {}'.f(pd.pageMode, _n_cnt, _n_rsvMaxCnt));
      if (
//        (global.t?.state.sgc_pageMode == 'new' && _n_cnt >= ff.n(_n_rsvMaxCnt)) ||
//        (global.t?.state.sgc_pageMode == 'edit' && _n_cnt+1 > ff.n(_n_rsvMaxCnt))
        (pd.pageMode == 'new' && _n_cnt >= ff.n(_n_rsvMaxCnt)) ||
        (pd.pageMode == 'edit' && _n_cnt+1 > ff.n(_n_rsvMaxCnt))
      ) {
        _b_sgl = false;
      }
    })
  }))
  .then(() => {
    _o_end1(_b_sgl);
  });
});

static op_chkSglI10r2 = (pd={ // 設備の予約重複の確認
  d_i1zrs: null,
  pageMode: null,
}) => new Promise( _o_end1 => {
  let _d_i1zrs = pd.d_i1zrs;
  if (ff.myCM_getLen(_d_i1zrs.dld_cldDatsss?.i1z2) > 0 ) {
    let _rsvDate = _d_i1zrs.d_flds.i1zri21d;
    let _b_sgl = true;
    Promise.all(
      _d_i1zrs.dld_cldDatsss?.i1z2
      .filter( _d_i1z2s => _d_i1z2s.b_dlt != true ? true : false)
      .map( _d_i1z2s => new Promise( _o_end3 => {
//ff.l('i1zv 1764: {}'.f(_d_i1z2s));
        let _rsvFly = _d_i1z2s.d_flds.i1z2b41f;
        let _n_rsvMaxCnt = _d_i1z2s.d_flds.i10ri11i;
        if (_n_rsvMaxCnt >= 1) {
          Promise.all(
            _d_i1zrs.dld_cldDatsss.i1z0
            .filter( _d_i1z0s => _d_i1z0s.b_dlt != true ? true : false)
            .map( _d_i1z0s => new Promise( _o_end4 => {
              let _rsvSttTime = _d_i1z0s.d_flds.i110i11t;
              let _rsvEndTime = _d_i1z0s.d_flds.i110i12t;
              i1zv.op_loadSlcList({
                elm: 'i1z0',
                o_cnd: _dd_datss => {
                  let _cnd1 = cf.c('i110', `i110i11t::NUMERIC::INTEGER < ${_rsvEndTime}  AND ${_rsvSttTime} < i110i12t::NUMERIC::INTEGER`);
                  let _cnd2 = cf.c('i1z2', `i1z2b41f = ${_rsvFly} AND i1z2b61k = i1z0b61k`);
                  let _cnd = `(SELECT COUNT(*) FROM t_i1z2 WHERE ${_cnd2}) > 0 AND t_i1z0.i1z0b51f IN (SELECT _fst FROM t_i110 WHERE ${_cnd1}) AND t_i1z0.i1z0i21d = "${_rsvDate}" AND t_i1z0.i1z0s11i IN (70, 80, 90)`;
                  if (pd.pageMode == 'edit') {
                    _cnd += ` AND t_i1z0.i1z0b61k NOT IN (SELECT t_i1zr._key FROM t_i1zr WHERE {})`.f(cf.c('i1zr', `t_i1zr._fst = ${_d_i1zrs.d_flds._fst}`)); // 自身以外の件数
                  };
                  _cnd = cf.c('i1z0', _cnd);
                  return _cnd;
                },
              })
              .then(() => {
                let _n_cnt = ff.myCM_getLen(global.t?.state.sdld_i1z0SlcListsss.i1z0);
//ff.l('i1zv 1787: {}, {}, {}, {}'.f(pd.pageMode, _n_cnt, _n_rsvMaxCnt, global.t?.state.sdld_i1z0SlcListsss.i1z0))
                if (
                  (pd.pageMode == 'new' && _n_cnt >= ff.n(_n_rsvMaxCnt)) ||
                  (pd.pageMode == 'edit' && _n_cnt+1 > ff.n(_n_rsvMaxCnt))
                ) {
                  _b_sgl = false;
                  _o_end4();
                }
                else {
                  _o_end4();
                };
              })
            }))
          )
          .then(() => {
            _o_end3();
          });
        }
        else {
          _o_end3();
        };
      }))
    )
    .then(() => {
      _o_end1(_b_sgl);
    });
  } else {
    _o_end1(true);
  };
});

static op_chkSglI10r3 = (pd={ // 設備の重複登録の確認
  d_i1zrs: null,
}) => new Promise( _o_end1 => {
  let _d_i1zrs = pd.d_i1zrs;
  if (ff.myCM_getLen(_d_i1zrs.dld_cldDatsss?.i1z2) > 0 ) {
    let _d_cnts = {};
    let _b_sgl = true;
    _d_i1zrs.dld_cldDatsss?.i1z2.filter( _d_i1z2s => (_d_i1z2s.b_dlt == true) ? false : true).map( _d_i1z2s => {
      let _i10r_fst = _d_i1z2s.d_flds.i1z2b41f;
      if ( ff.f(_d_cnts[_i10r_fst]) == false ) _d_cnts[_i10r_fst] = 0;
      _d_cnts[_i10r_fst] += 1;
//ff.l('1781: {}'.f(_d_cnts))
      if ( _d_cnts[_i10r_fst] > 1 ) {
        _b_sgl = false;
      };
    });
//ff.l('1785: {}'.f(_b_sgl))
    _o_end1(_b_sgl);
  } else {
    _o_end1(true);
  };
});

}
